<template>
  <div>
    <p v-if="showFileName">Filename: {{ fileName }}</p>
    <div v-if="value">
      <el-button
        v-if="isImage || isEmbedSupport"
        @click="showDialog"
        type="primary"
      >
        Preview
      </el-button>
      <el-button @click="onDownload"> Download </el-button>
    </div>
    <p v-else>Document not attached</p>
    <el-dialog
      title="Document preview"
      append-to-body
      width="50vw"
      :visible.sync="dialogVisible"
    >
      <img
        v-if="isImage"
        class="img-fluid img-preview"
        :src="url"
        alt="Image preview"
      />
      <embed
        v-else-if="dialogVisible && isEmbedSupport"
        :src="url"
        class="pdf-preview"
      />
      <span slot="footer" class="dialog-footer" />
    </el-dialog>
  </div>
</template>

<script>
import { downloadImgByProxy, getFileName } from '../common/js/imgproxy'

export default {
  data() {
    return {
      url: '',
      dialogVisible: false,
      fileName: '',
      isImage: false,
      isEmbedSupport: false,
      numPages: 0
    }
  },
  props: {
    value: {
      type: String
    },
    showFileName: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(fileUrl) {
        this.setMediaData(fileUrl)
      }
    }
  },
  methods: {
    getFileName,
    downloadImgByProxy,
    setMediaData(fileUrl) {
      if (!fileUrl) return
      this.fileName = getFileName(fileUrl)
      const extension = this.fileName.split('.').pop().toLowerCase()
      this.url = fileUrl
      this.isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(extension)
      this.isEmbedSupport = ['pdf', 'mp4'].includes(extension)
    },
    showDialog() {
      this.dialogVisible = true
    },
    onDownload() {
      if (this.isImage) this.downloadImgByProxy(this.url, this.fileName)
      else window.open(this.url, '_blank')
    }
  }
}
</script>
<style>
.img-preview {
  width: 100%;
}

.pdf-preview {
  width: 100%;
  height: 65vh;
}
</style>
